var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcVerified(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "-16.1349081%",
    x2: "77.5180577%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D341",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009D51",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-Screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Verify-1",
    transform: "translate(-341.000000, -458.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(341.000000, 458.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    cx: 9,
    cy: 9,
    r: 9
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.7170492,6.2025 L7.98748356,13.2075 C7.6127778,13.5975 7.01324859,13.5975 6.63854282,13.2075 L3.28102932,9.6825 C2.90632356,9.2925 2.90632356,8.6625 3.28102932,8.2725 C3.65573508,7.8825 4.2552643,7.8825 4.62997006,8.2725 L7.32785154,11.09265 L13.3832465,4.7925 C13.7579523,4.4025 14.3574815,4.4025 14.7321873,4.7925 C15.0917549,5.1825 15.0917549,5.8125 14.7170492,6.2025",
    id: "Fill-1",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.7170492,6.2025 L7.98748356,13.2075 C7.6127778,13.5975 7.01324859,13.5975 6.63854282,13.2075 L3.28102932,9.6825 C2.90632356,9.2925 2.90632356,8.6625 3.28102932,8.2725 C3.65573508,7.8825 4.2552643,7.8825 4.62997006,8.2725 L7.32785154,11.09265 L13.3832465,4.7925 C13.7579523,4.4025 14.3574815,4.4025 14.7321873,4.7925 C15.0917549,5.1825 15.0917549,5.8125 14.7170492,6.2025",
    id: "Fill-1",
    fill: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVerified);
export default __webpack_public_path__ + "static/media/ic_verified.799dc16be11c12f6272a0ca3f43697b4.svg";
export { ForwardRef as ReactComponent };